import { AxiosProgressEvent } from 'axios'
import service from './request'
import Qs from 'qs'
/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function $fetch<T = any>(url: string, params = {}):Promise<T> {
  return new Promise((resolve, reject) => {
    service
      .get(url, {
        params: params,
        paramsSerializer: {
          serialize: function (params) {
            return Qs.stringify(params, {
              arrayFormat: 'repeat'
            });
          }
        }
      })
      .then((response) => {
        resolve(response as T);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function $post<T = any>(url: string, data = {}):Promise<T> {
  return new Promise((resolve, reject) => {
    service.post(url, data).then(
      (response) => {
        resolve(response as T);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

/**
 * 自定义上传加载进度条
 * @param url
 * @param data
 * @param callback
 * @returns {Promise}
 */
export function $post_file (url: string, data = {}, callback: (arg0: AxiosProgressEvent) => void) {
  return new Promise((resolve, reject) => {
    service({
      method: 'post',
      url,
      data,
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: function (progressEvent) {
        callback(progressEvent)
      }
    }).then(
      response => {
        resolve(response)
      },
      err => {
        reject(err)
      }
    )
  })
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function $post_form(url: string, data = {}) {
  return new Promise((resolve, reject) => {
    service
      .post(url, data, { headers: { 'Content-Type': 'multipart/form-data' }})
      .then(
        (response) => {
          resolve(response);
        },
        (err) => {
          reject(err);
        }
      );
  });
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function $patch(url: string, data = {}) {
  return new Promise((resolve, reject) => {
    service.patch(url, data).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function $put(url: string, data = {}) {
  return new Promise((resolve, reject) => {
    service.put(url, data).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

export function $delete(url: string, data = {}) {
  return new Promise((resolve, reject) => {
    service
      .delete(url, {
        data: data
      })
      .then(
        (response) => {
          resolve(response);
        },
        (err) => {
          reject(err);
        }
      );
  });
}

export function $preview(url: string, params: any) {
  return new Promise((resolve, reject) => {
    service({
      method: 'get',
      url: url,
      params: params,
      responseType: 'blob'
    })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}
// // 返回响应内容
// export function $downloadResponse(url: string, params: any) {
//   return new Promise((resolve, reject) => {
//     service({
//       method: 'get',
//       url: url,
//       params: params,
//       responseType: 'blob',
//       onDownloadProgress: (progress) => {
//       }
//     })
//       .then((res) => {
//         resolve(res);
//         // downloadFile(res.data || res, fileName)
//       })
//       .catch((err) => {
//         reject(err.data);
//       });
//   });
// }
